// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import FileWordOutlinedSvg from "@fishx/icons-svg/es/asn/FileWordOutlined";
import FishxIcon from '../components/FishxIcon';

var FileWordOutlined = function FileWordOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: FileWordOutlinedSvg
  }));
};

FileWordOutlined.displayName = 'FileWordOutlined';
export default React.forwardRef(FileWordOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/FileWordOutlined.js
// module id = 2757
// module chunks = 0